export default __webpack_public_path__ + "static/media/dark.b196a0b9.svg";